(function() { window.GUID_ea758c1e_977d_4b0f_a26c_35ffdc9c82de = { getGuid: function() { return "ea758c1e-977d-4b0f-a26c-35ffdc9c82de"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class CompareWidget extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.homePersonaPickerId = `cs-persona-picker-${this.ControlId.toLowerCase()}-homepersonapicker`;
                this.awayPersonaPickerId = `cs-persona-picker-${this.ControlId.toLowerCase()}-awaypersonapicker`;
                this.actionButtonId = `button-${this.ControlId.toLowerCase()}-main-action`;
                this.showHomeProfileButtonId = `button-${this.ControlId.toLowerCase()}-show-home-profile`;
                this.showAwayProfileButtonId = `button-${this.ControlId.toLowerCase()}-show-away-profile`;
                try {
                    const eventId = params[1];
                    if (!CS.Helper.isNullOrWhiteSpace(eventId)) {
                        this.eventId = parseInt(eventId);
                    }
                    else {
                        this.eventId = null;
                    }
                    const divisionId = params[2];
                    if (!CS.Helper.isNullOrWhiteSpace(divisionId)) {
                        this.divisionId = parseInt(divisionId);
                    }
                    else {
                        this.divisionId = null;
                    }
                }
                catch (error) {
                    console.error("Error parsing event and division ids", error);
                }
                this.parseHiddenData();
            }
            OnBindEvents() {
                this.$Control.offon("click.opponent-container", ".opponent-container", this.handleOpponentClick.bind(this));
                Controls.PersonaPicker.Events.PersonaItemClicked({
                    selector: "body",
                    childSelector: `#${this.homePersonaPickerId}`,
                    callback: (personaPicker, e) => this.handlePersonaItemClicked(personaPicker, e.data.personaId, e.data.name, e.data.avatar, "home", e.data.sportsIds),
                });
                Controls.PersonaPicker.Events.PersonaItemClicked({
                    selector: "body",
                    childSelector: `#${this.awayPersonaPickerId}`,
                    callback: (personaPicker, e) => this.handlePersonaItemClicked(personaPicker, e.data.personaId, e.data.name, e.data.avatar, "away", e.data.sportsIds),
                });
                this.$Control.offon("click.compare-button", `#${this.actionButtonId}`, this.handleCompareButtonClick.bind(this));
                this.$Control.offon("click.show-home-profile-button", `#${this.showHomeProfileButtonId}`, this.handleShowProfileButtonClick.bind(this));
                this.$Control.offon("click.show-away-profile-button", `#${this.showAwayProfileButtonId}`, this.handleShowProfileButtonClick.bind(this));
                if (this.showCSR) {
                    this.fetchCSR();
                }
            }
            fetchCSR() {
                try {
                    const url = CS.Url.CSUrl("GetCSRLabels");
                    if (CS.Helper.isNullOrWhiteSpace(url)) {
                        throw new Error("CSR url is null or empty");
                    }
                    const $homeCSRContainer = this.$Control.find(`#${this.ControlId.toLowerCase()}-home-csr`);
                    const $awayCSRContainer = this.$Control.find(`#${this.ControlId.toLowerCase()}-away-csr`);
                    if ($homeCSRContainer) {
                        CS.Helper.ShowLoader({
                            id: this.ControlId.toLowerCase() + "-home-csr-loader",
                            $container: () => $homeCSRContainer,
                            position: "prepend",
                            autoRemoveDelay: 1000,
                            overContent: true,
                        });
                    }
                    if ($awayCSRContainer) {
                        CS.Helper.ShowLoader({
                            id: this.ControlId.toLowerCase() + "-away-csr-loader",
                            $container: () => $awayCSRContainer,
                            position: "prepend",
                            autoRemoveDelay: 1000,
                            overContent: true,
                        });
                    }
                    const removeHomeLoader = () => {
                        CS.Helper.RemoveLoader({
                            id: this.ControlId.toLowerCase() + "-home-csr-loader",
                            $container: $homeCSRContainer,
                        });
                    };
                    const removeAwayLoader = () => {
                        CS.Helper.RemoveLoader({
                            id: this.ControlId.toLowerCase() + "-away-csr-loader",
                            $container: $awayCSRContainer,
                        });
                    };
                    const personaIds = `${this.state.homeOpponent.personaId},${this.state.awayOpponent.personaId}`;
                    CS.Ajax.Get(url, { personaIds }, (response) => {
                        const $response = $(response);
                        if (!$response.length) {
                            removeHomeLoader();
                            removeAwayLoader();
                            return;
                        }
                        const $items = $response.find(".csr-item");
                        $items.each((index, item) => {
                            let $container = null;
                            if (index === 0) {
                                $container = this.$Control.find(`#${this.ControlId.toLowerCase()}-home-csr`);
                                removeHomeLoader();
                            }
                            else if (index === 1) {
                                $container = this.$Control.find(`#${this.ControlId.toLowerCase()}-away-csr`);
                                removeAwayLoader();
                            }
                            if ($container == null || !$container.length) {
                                return;
                            }
                            $container.html(item.outerHTML);
                        });
                    });
                }
                catch (error) {
                    console.error("Error fetching CSR", error);
                }
            }
            handleShowProfileButtonClick(e) {
                try {
                    if (!this.personaWallUrl) {
                        return;
                    }
                    const $button = $(e.currentTarget);
                    const isHome = $button.hasClass("home");
                    const isAway = $button.hasClass("away");
                    if (!isHome && !isAway) {
                        return;
                    }
                    let $opponentContainer = null;
                    if (isHome) {
                        $opponentContainer = this.$Control.find(`#${this.ControlId.toLowerCase()}-home`);
                    }
                    if (isAway) {
                        $opponentContainer = this.$Control.find(`#${this.ControlId.toLowerCase()}-away`);
                    }
                    if ($opponentContainer == null || !$opponentContainer.length) {
                        return;
                    }
                    const personaId = $opponentContainer.attr("data-personaid");
                    if (!personaId) {
                        return;
                    }
                    const url = this.personaWallUrl.replace(CS.Helper.IntMinValue.toString(), personaId);
                    if (!url) {
                        return;
                    }
                    CS.Nav.Go(url);
                }
                catch (error) {
                    console.error("Show profile button click error", error);
                }
            }
            handleOpponentClick(e) {
                try {
                    const $opponentContainer = $(e.currentTarget);
                    const isHome = $opponentContainer.hasClass("home");
                    const isAway = $opponentContainer.hasClass("away");
                    if (!isHome && !isAway) {
                        return;
                    }
                    const $hiddenElements = this.$Control.find(".hidden-elements");
                    if (!$hiddenElements.length) {
                        return;
                    }
                    let $personaPicker = null;
                    if (isHome) {
                        $personaPicker = $hiddenElements.find(`#${this.homePersonaPickerId}`);
                    }
                    if (isAway) {
                        $personaPicker = $hiddenElements.find(`#${this.awayPersonaPickerId}`);
                    }
                    if ($personaPicker == null || !$personaPicker.length) {
                        return;
                    }
                    $personaPicker.trigger("click");
                }
                catch (error) {
                    console.error("Opponent container click error", error);
                }
            }
            handleCompareButtonClick() {
                try {
                    if (!this.comparePlayersUrl || !this.compareTeamsUrl || !this.state) {
                        return;
                    }
                    const { homeOpponent, awayOpponent } = this.state;
                    if (!homeOpponent || !awayOpponent) {
                        return;
                    }
                    const bothSelected = homeOpponent.personaId && awayOpponent.personaId;
                    if (!bothSelected) {
                        return;
                    }
                    const sameOpponentType = homeOpponent.isTeam === awayOpponent.isTeam;
                    if (!sameOpponentType) {
                        return;
                    }
                    const isTeam = homeOpponent.isTeam;
                    if (isTeam) {
                        const _url = this.compareTeamsUrl;
                        const teamIds = `${homeOpponent.personaId},${awayOpponent.personaId}`.replace(/t/g, "");
                        const url = _url.replace(CS.Helper.IntMinValue.toString(), teamIds);
                        if (CS.Helper.isNullOrWhiteSpace(url)) {
                            return;
                        }
                        CS.Nav.Go(url);
                    }
                    else {
                        const _url = this.comparePlayersUrl;
                        const url = _url
                            .replace(CS.Helper.IntMinValue.toString(), homeOpponent.personaId)
                            .replace(CS.Helper.IntMinValue.toString(), awayOpponent.personaId);
                        if (CS.Helper.isNullOrWhiteSpace(url)) {
                            return;
                        }
                        CS.Nav.Go(url);
                    }
                }
                catch (error) {
                    console.error("Compare button click error", error);
                }
            }
            handlePersonaItemClicked(personaPicker, personaId, name, avatar, side, sportsIds) {
                const $footer = this.$Control.find(".compare-widget__footer");
                if ($footer.length) {
                    $footer.css("display", "flex");
                }
                personaPicker.CloseDropDown();
                const selectedOpponent = {
                    personaId,
                    name,
                    avatar,
                    isTeam: personaId && personaId.indexOf("t") === 0,
                    isLastSelected: true,
                    sportsIds,
                };
                const otherOpponent = side === "home" ? this.state.awayOpponent : this.state.homeOpponent;
                this.update({
                    homeOpponent: side === "home" ? selectedOpponent : otherOpponent,
                    awayOpponent: side === "away" ? selectedOpponent : otherOpponent,
                    selected: side,
                });
            }
            OnDispose() { }
            OnControlRendered() { }
            parseHiddenData() {
                try {
                    const $hiddenElements = this.$Control.find(".hidden-elements");
                    if (!$hiddenElements.length) {
                        return;
                    }
                    const $disabledItemsWithoutSportsInCommon = $hiddenElements.find(`input#${this.ControlId}-DisabledItemsWithoutSportsInCommon`);
                    if ($disabledItemsWithoutSportsInCommon.length) {
                        this.disabledItemsWithoutSportsInCommon =
                            $disabledItemsWithoutSportsInCommon.val() == "true";
                    }
                    else {
                        this.disabledItemsWithoutSportsInCommon = false;
                    }
                    const $comparePlayersUrl = $hiddenElements.find(`input#${this.ControlId}-ComparePlayersUrl`);
                    if ($comparePlayersUrl.length) {
                        this.comparePlayersUrl = $comparePlayersUrl.val();
                    }
                    const $compareTeamsUrl = $hiddenElements.find(`input#${this.ControlId}-CompareTeamsUrl`);
                    if ($compareTeamsUrl.length) {
                        this.compareTeamsUrl = $compareTeamsUrl.val();
                    }
                    const $personaWallUrl = $hiddenElements.find(`input#${this.ControlId}-PersonaWallUrl`);
                    if ($personaWallUrl.length) {
                        this.personaWallUrl = $personaWallUrl.val();
                    }
                    const $showCSR = $hiddenElements.find(`input#${this.ControlId}-ShowCSR`);
                    if ($showCSR.length) {
                        this.showCSR = $showCSR.val() == "true";
                    }
                    const $homePersona = $hiddenElements.find(`input#${this.ControlId}-HomePersona`);
                    const $awayPersona = $hiddenElements.find(`input#${this.ControlId}-AwayPersona`);
                    if (!$homePersona.length || !$awayPersona.length) {
                        return;
                    }
                    let homePersona;
                    try {
                        homePersona = $homePersona.length
                            ? JSON.parse($homePersona.val())
                            : null;
                    }
                    catch (error) {
                        homePersona = null;
                    }
                    let homePersonaId = null;
                    let homePersonaName = "";
                    let homePersonaAvatar = "";
                    let homePersonaSportsIds = "";
                    if (homePersona) {
                        homePersonaId = homePersona.PersonaId;
                        homePersonaName = homePersona.PersonaName;
                        homePersonaAvatar = homePersona.PersonaImgUrl;
                        const $homePersonaSportsIds = $hiddenElements.find(`input#${this.ControlId}-HomeSports`);
                        if ($homePersonaSportsIds.length) {
                            homePersonaSportsIds = $homePersonaSportsIds.val();
                        }
                    }
                    let awayPersona;
                    try {
                        awayPersona = $awayPersona.length
                            ? JSON.parse($awayPersona.val())
                            : null;
                    }
                    catch (error) {
                        awayPersona = null;
                    }
                    let awayPersonaId = null;
                    let awayPersonaName = "";
                    let awayPersonaAvatar = "";
                    let awayPersonaSportsIds = "";
                    if (awayPersona) {
                        awayPersonaId = awayPersona.PersonaId;
                        awayPersonaName = awayPersona.PersonaName;
                        awayPersonaAvatar = awayPersona.PersonaImgUrl;
                        const $awayPersonaSportsIds = $hiddenElements.find(`input#${this.ControlId}-AwaySports`);
                        if ($awayPersonaSportsIds.length) {
                            awayPersonaSportsIds = $awayPersonaSportsIds.val();
                        }
                    }
                    this.update({
                        homeOpponent: {
                            personaId: homePersonaId,
                            name: homePersonaName,
                            avatar: homePersonaAvatar,
                            isTeam: homePersonaId && homePersonaId.indexOf("t") === 0,
                            isLastSelected: false,
                            sportsIds: homePersonaSportsIds,
                        },
                        awayOpponent: {
                            personaId: awayPersonaId,
                            name: awayPersonaName,
                            avatar: awayPersonaAvatar,
                            isTeam: awayPersonaId && awayPersonaId.indexOf("t") === 0,
                            isLastSelected: false,
                            sportsIds: awayPersonaSportsIds,
                        },
                        selected: "none",
                    });
                }
                catch (error) {
                    console.error("Error parsing hidden data", error);
                }
            }
            update({ homeOpponent, awayOpponent, selected, }) {
                if (selected === "home") {
                    this.setOpponent("home", homeOpponent);
                }
                else if (selected === "away") {
                    this.setOpponent("away", awayOpponent);
                }
                const homeSelected = !CS.Helper.isNullOrWhiteSpace(homeOpponent.personaId);
                const awaySelected = !CS.Helper.isNullOrWhiteSpace(awayOpponent.personaId);
                const bothSelected = homeSelected && awaySelected;
                const anySelected = homeSelected || awaySelected;
                const sameOpponentType = bothSelected && homeOpponent.isTeam === awayOpponent.isTeam;
                const sameOpponent = bothSelected && homeOpponent.personaId === awayOpponent.personaId;
                const newState = {
                    homeOpponent,
                    awayOpponent,
                };
                // If it's the same opponent, reset the one that was not selected
                if (sameOpponent) {
                    if (selected === "home") {
                        newState.awayOpponent = {
                            personaId: null,
                            avatar: null,
                            name: null,
                            isLastSelected: false,
                            isTeam: newState.homeOpponent.isTeam,
                        };
                        this.resetOpponent("away", newState.awayOpponent.isTeam);
                    }
                    else if (selected === "away") {
                        newState.homeOpponent = {
                            personaId: null,
                            avatar: null,
                            name: null,
                            isLastSelected: false,
                            isTeam: newState.awayOpponent.isTeam,
                        };
                        this.resetOpponent("home", newState.homeOpponent.isTeam);
                    }
                    else {
                        newState.homeOpponent = {
                            personaId: null,
                            avatar: null,
                            name: null,
                            isLastSelected: false,
                            isTeam: newState.homeOpponent.isTeam,
                        };
                        newState.awayOpponent = {
                            personaId: null,
                            avatar: null,
                            name: null,
                            isLastSelected: false,
                            isTeam: newState.awayOpponent.isTeam,
                        };
                        this.resetOpponent("home", newState.homeOpponent.isTeam);
                        this.resetOpponent("away", newState.awayOpponent.isTeam);
                    }
                }
                // If both selected but not same type, reset the one that was not selected
                if (bothSelected && !sameOpponentType) {
                    if (selected === "home") {
                        newState.awayOpponent = {
                            personaId: null,
                            avatar: null,
                            name: null,
                            isLastSelected: false,
                            isTeam: newState.homeOpponent.isTeam,
                        };
                        this.resetOpponent("away", newState.awayOpponent.isTeam);
                    }
                    else if (selected === "away") {
                        newState.homeOpponent = {
                            personaId: null,
                            avatar: null,
                            name: null,
                            isLastSelected: false,
                            isTeam: newState.awayOpponent.isTeam,
                        };
                        this.resetOpponent("home", newState.homeOpponent.isTeam);
                    }
                    else {
                        newState.homeOpponent = {
                            personaId: null,
                            avatar: null,
                            name: null,
                            isLastSelected: false,
                            isTeam: newState.homeOpponent.isTeam,
                        };
                        newState.awayOpponent = {
                            personaId: null,
                            avatar: null,
                            name: null,
                            isLastSelected: false,
                            isTeam: newState.awayOpponent.isTeam,
                        };
                        this.resetOpponent("home", newState.homeOpponent.isTeam);
                        this.resetOpponent("away", newState.awayOpponent.isTeam);
                    }
                }
                // If only one selected, reset the other one with the same type
                if (!bothSelected && anySelected) {
                    if (homeOpponent.personaId) {
                        newState.awayOpponent = {
                            personaId: null,
                            avatar: null,
                            name: null,
                            isLastSelected: false,
                            isTeam: homeOpponent.isTeam,
                        };
                        this.resetOpponent("away", newState.awayOpponent.isTeam);
                    }
                    else if (awayOpponent.personaId) {
                        newState.homeOpponent = {
                            personaId: null,
                            avatar: null,
                            name: null,
                            isLastSelected: false,
                            isTeam: awayOpponent.isTeam,
                        };
                        this.resetOpponent("home", newState.homeOpponent.isTeam);
                    }
                }
                // If none selected, reset both
                if (!anySelected) {
                    newState.homeOpponent = {
                        personaId: null,
                        avatar: null,
                        name: null,
                        isLastSelected: false,
                        isTeam: false,
                    };
                    newState.awayOpponent = {
                        personaId: null,
                        avatar: null,
                        name: null,
                        isLastSelected: false,
                        isTeam: false,
                    };
                    this.resetOpponent("home", false);
                    this.resetOpponent("away", false);
                }
                this.state = newState;
                const $compareButton = this.$Control.find(".compare-widget__footer .button");
                const canCompare = this.state.homeOpponent.personaId && this.state.awayOpponent.personaId;
                if ($compareButton.length) {
                    if (canCompare) {
                        CS.Helper.enableButton($compareButton);
                    }
                    else {
                        CS.Helper.disableButton($compareButton);
                    }
                    this.fetchCSR();
                }
                else {
                    if (canCompare && selected !== "none") {
                        this.handleCompareButtonClick();
                    }
                }
            }
            resetOpponent(side, isTeam) {
                try {
                    const $otherOpponentPersonaPicker = this.$Control.find(`#${side === "home"
                        ? this.awayPersonaPickerId
                        : this.homePersonaPickerId}`);
                    if ($otherOpponentPersonaPicker.length) {
                        $otherOpponentPersonaPicker.attr("data-persona-sports", "");
                    }
                    const $showProfileButton = side === "home"
                        ? this.$Control.find(`#${this.showHomeProfileButtonId}`)
                        : this.$Control.find(`#${this.showAwayProfileButtonId}`);
                    if ($showProfileButton.length) {
                        CS.Helper.disableButton($showProfileButton);
                    }
                    const $opponentContainer = this.$Control.find(`.opponent-container.${side}`);
                    if (!$opponentContainer.length) {
                        return;
                    }
                    $opponentContainer.attr("data-personaid", "");
                    $opponentContainer.removeClass("selected");
                    const $picHelpers = $opponentContainer.find(".pic-helper");
                    if ($picHelpers.length) {
                        $picHelpers.addClass("hiddenforced");
                        // Find one that has class "default-player" or "default-team
                        const $defaultPicHelper = isTeam
                            ? $picHelpers.filter(".default-team")
                            : $picHelpers.filter(".default-player");
                        if ($defaultPicHelper.length) {
                            $defaultPicHelper.removeClass("hiddenforced");
                        }
                    }
                    const $name = $opponentContainer.find(".name");
                    if ($name.length) {
                        $name.text(JSRess.SelectAnOpponent);
                    }
                }
                catch (error) {
                    console.error("Error resetting opponent", error);
                }
            }
            setOpponent(side, opponent) {
                try {
                    const $otherOpponentPersonaPicker = this.$Control.find(`#${side === "home"
                        ? this.awayPersonaPickerId
                        : this.homePersonaPickerId}`);
                    if ($otherOpponentPersonaPicker.length) {
                        $otherOpponentPersonaPicker.attr("data-persona-sports", opponent.sportsIds);
                    }
                    const $showProfileButton = side === "home"
                        ? this.$Control.find(`#${this.showHomeProfileButtonId}`)
                        : this.$Control.find(`#${this.showAwayProfileButtonId}`);
                    if ($showProfileButton.length) {
                        CS.Helper.enableButton($showProfileButton);
                    }
                    const $opponentContainer = this.$Control.find(`.opponent-container.${side}`);
                    if (!$opponentContainer.length) {
                        return;
                    }
                    $opponentContainer.attr("data-personaid", opponent.personaId);
                    $opponentContainer.addClass("selected");
                    const $picHelpers = $opponentContainer.find(".pic-helper");
                    if ($picHelpers.length) {
                        $picHelpers.addClass("hiddenforced");
                        const $picHelper = $picHelpers.filter(":not(.default-team):not(.default-player)");
                        if ($picHelper.length) {
                            $picHelper.removeClass("hiddenforced");
                            $picHelper.find("img").attr("src", opponent.avatar);
                        }
                    }
                    const $name = $opponentContainer.find(".name");
                    if ($name.length) {
                        $name.text(opponent.name);
                    }
                }
                catch (error) {
                    console.error("Error setting opponent", error);
                }
            }
        }
        Controls.CompareWidget = CompareWidget;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=compare-widget.js.map
